export default __webpack_public_path__ + "static/media/cadre_noir-eval.a29bdbd5.png";